module.exports = __webpack_public_path__ + "static/media/system_vs_manual_bulkupload.7c16a55d.csv";